<script setup>
import { ref, computed, onMounted } from 'vue'
import dayjs from 'dayjs'
import ja from 'dayjs/locale/ja'
import learningApiUser from '@src/services/api/learning/user'
import { useRouter } from 'vue-router'
import Pager from '@components/Pager.vue'

dayjs.locale(ja)

const router = useRouter()
const traineeList = ref({})
const showCancelTrainee = ref(false)

const pageParams = ref({
  page: 1,
  pageCount: 1,
  pagination: 10
})
const pageTotal = ref(0)

const getTrainees = (page) => {
  console.log('getTrainees', page)
  pageParams.value.page = page
  if (!showCancelTrainee.value) {
    pageParams.value.enabled = 't'
  } else {
    delete pageParams.value.enabled
  }
  learningApiUser.getTrainee({params: {with: 'course.location', ...pageParams.value}}).then((res) => {
    console.log('getTraniee res', res)
    traineeList.value = res.data
    pageParams.value.page = Number(res.headers.get('x-page'))
    pageParams.value.pageCount = Number(res.headers.get('x-page-count'))
    pageTotal.value = Number(res.headers.get('x-total'))
  }).catch((err) => {
    console.error('login err', err)
  })
}

const changeShowCancelTrainee = () => {
  getTrainees(1)
}

const openInquiry = () => {
  const routeData = router.resolve({ name: 'Inquiry' })
  window.open(routeData.href, '_blank')
}

const getStatus = (enabled, attendance) => {
  if (enabled === 'f') {
    return 'キャンセル'
  } else if (attendance === null) {
    return '受講前'
  } else if (attendance === true) {
    return '出席'
  } else {
    return '欠席'
  }
}

onMounted(() => {
  console.log('mounted')
  getTrainees(1)
})
</script>

<template>
  <div class="container">
    <h2>受講履歴</h2>
    <p>
      現在お申込み中及び過去受講された講座の情報を表示します。<br>
      受講履歴の詳細を閲覧するには、詳細をクリックして下さい。<br>
      また、未受講の講座を変更、決済完了後の講座をキャンセルする場合は、受付・管理センターまでご連絡ください。
    </p>
    <p>
      一般社団法人日本コンタクトレンズ協会 継続的研修受付・管理センター<br>
      電話番号: 03-6205-5031 FAX番号: 03-5155-1536<br>
      お問い合わせは<a href="#" @click="openInquiry">こちら</a  >
      （10:00～17:00受付 土・日・祝日除く）
    </p>
    <p>
      過去6年より以前分は継続的研修受付・管理センターにお問合せ下さい
    </p>

    <div class="showCancelTraineeCotainer">
      <label>
        <input
          v-model="showCancelTrainee"
          :value="showCancelTrainee"
          name="item"
          type="checkbox"
          @change="changeShowCancelTrainee"
        >
        キャンセルを表示
      </label>
    </div>

    <Pager
      :pageInfo="pageParams"
      :total="pageTotal"
      @changePage="getTrainees"
    />

    <!-- 会場講座 -->
    <div class="scroll-box">
      <table v-if="traineeList.length > 0">
        <thead>
          <tr>
            <th>年度</th>
            <th>講座名称</th>
            <th>講座タイプ</th>
            <th>開催期間</th>
            <th>支払い状況</th>
            <th>受講状態</th>
            <th width="110"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in traineeList"
            :key="'course' + index"
            @click="router.push({name: 'TraineeDetail', params: { courseId: item.id }})"
          >
            <td>
              {{ item.course?.year }}
            </td>
            <td>
              {{ item.course?.displays && item.course.displays.name ? item.course.displays.name : '' }}
            </td>
            <td>
              {{ item.course?.type === 'online' ? (item.course?.besent ? 'オンデマンド＋DVD' : 'オンデマンド') : '会場受講' + '(' + item.course?.location?.displays?.name + ')' }}
            </td>
            <td>
              {{ dayjs(item.course?.term[0]).format('YYYY/MM/DD(dd) HH:mm') }}～<br>
              {{ dayjs(item.course?.term[1]).format('YYYY/MM/DD(dd) HH:mm') }}
            </td>
            <td>
              {{ item.payment_status === 1 ? '支払済' : item.payment_status === -1 ? '未払い' : '返金済'}}
            </td>
            <td>
              {{ getStatus(item.enabled, item.attendance) }}
            </td>
            <td>
              <button @click="router.push({name: 'TraineeDetail', params: { courseId: item.id }})">
                詳細
              </button>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-else>
        <p>受講履歴はありません</p>
      </div>
    </div>

    <!-- フッター -->
    <div class="btnContainer">
      <button
        class="c-button c-button--medium c-button--border"
        @click="router.push({name: 'Dashboard'})"
      >
        トップページに戻る
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.container {
  h2 {
    padding: 30px 0 15px;
    font-size: 26px;
    text-align: left;
    font-weight: bold;
  }

  p {
    margin-bottom: 15px;
  }

  h3 {
    padding: 5px 10px;
    margin: 0 0 10px;
    border-left: 6px solid #00008b;
    font-size: 17.6px;
    font-weight: bold;
  }

  .showCancelTraineeCotainer {
    display: inline-block;
    margin: 20px 16px 2px 0;
    font-size: 14px;

    input {
      vertical-align: -1px;
      appearance: auto;
    }
  }

  table {
    min-width: 780px;

    thead {
      background: #eaeaea;
      border-bottom: 1px solid #ddd;

      th {
        border: none;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.4;
        padding: 6px 15px;
        text-align: left;

        &:nth-child(1) {
          width: 80px;
        }
        &:nth-child(2) {
          width: 200px;
        }
        &:nth-child(3) {
          width: 160px;
        }
        &:nth-child(4) {
          width: 215px;
        }
        &:nth-child(5) {
          width: 85px;
        }
        &:nth-child(6) {
          width: 90px;
        }
        &:nth-child(7) {
          width: 100px;
        }
      }
    }
    tbody {
      td {
        border-top: 1px solid #ddd;
        font-size: 16px;
        line-height: 1.3;
        padding: 12px 15px;
        vertical-align: middle;
        word-break: break-word;

        button {
          display: inline-block;
          width: auto;
          padding: 5px 15px;
          margin-left: 10px;
          background: #ffbf00;
          color: #fff;
          text-align: center;
          font-size: 1.4rem;
          color: #000;
          border-radius: 8px;
          text-decoration: none;
          vertical-align: middle;
        }
      }
      tr:last-child td {
        border-bottom: 1px solid #ddd;
      }
    }
  }

  .courseDetail {
    width: 100%;

    table {
      width: 100%;
      border-top: 1px solid #ddd;
      
      th {
        width: 140px;
        height: 100%;
        padding: 8px 15px 10px;
        background: #eaeaea;
        border-bottom: 1px solid #ddd;
        font-size: 16px;
      }

      td {
        width: calc(100% - 140px);
        padding: 8px 15px 10px;
        border-bottom: 1px solid #ddd;
        font-size: 16px;

        button {
          display: inline-block;
          width: auto;
          padding: 5px 15px;
          margin-right: 10px;
          background: #ffbf00;
          color: #fff;
          text-align: center;
          font-weight: bold;
          font-size: 1.6rem;
          border-radius: 5px;
          text-decoration: none;
          vertical-align: middle;
        }
      }
    }
  }

  .btnContainer {
    display: flex;
    width: auto;
    margin: 20px auto;
    justify-content: center;

    button {
      width: 200px;

      &:nth-child(2) {
        margin-left: 20px;
      }
    }
  }
}
</style>
